// extracted by mini-css-extract-plugin
export default {"absolute":"Loading_absolute__PyOBr","withBg":"Loading_withBg__aew-6"};